import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useRef} from 'react';
import {createPortal} from 'react-dom';
import useFocusTrap from 'utils/hooks/useFocusTrap';
import styles from './Drawer.module.scss';

export interface DrawerProps {
  children: JSX.Element;
  open?: boolean;
  toggleDrawer(drawerState: boolean): void;
  variant?: 'bottom' | 'right';
}

function Drawer({
  children,
  open = false,
  toggleDrawer,
  variant = 'bottom',
}: DrawerProps): JSX.Element {
  const drawerRef = useRef<HTMLDialogElement>(null);
  useFocusTrap(drawerRef);
  const visibilty = open ? styles.visible : '';

  // TO-DO: sematicaly is better to use <dialog> for this
  // but it would take too much time to implement it and test correctly
  // solution for more semantical dialog animation: https://www.cssscript.com/accessible-modal-dialog-animations/

  return createPortal(
    <>
      <span
        aria-hidden
        role="button"
        data-testid="drawerBackdrop"
        onClick={() => toggleDrawer(false)}
        className={`${styles.backgroundMask} ${visibilty}`}
      />
      <aside
        ref={drawerRef}
        data-testid="drawer"
        className={`${styles.drawer} ${visibilty} ${styles[variant]}`}
      >
        <button
          type="button"
          aria-label="Fechar"
          data-testid="closeDrawerButton"
          onClick={() => toggleDrawer(false)}
        >
          <FontAwesomeIcon icon="chevron-down" />
        </button>
        {children}
      </aside>
    </>,
    document.body,
  );
}

export default Drawer;
